interface MenuItemsProps {
  id: number;
  novidade?: any;
  label: string;
  icon?: string;
  link?: string;
  badge?: string;
  badgecolor?: string;
  subItems?: any;
  isHeader?: boolean;
}

const menuItems: Array<MenuItemsProps> = [

  {
    id: 2,
    label: "Painel de Controlo",
    icon: "monitor",
    link: "/control-panel",
    //badge: "5+",
    badgecolor: "badge rounded-pill badge-secondary-subtle",
  },  
  {
    id: 17,
    label: "Listar Actividades",
    link: "/projects",
    icon: "list",
  },
  {
    id: 18,
    label: "Adicionar Actividade",
    link: "/projects-create",
    icon: "plus",
    
  },
  {
    id: 3,
    label: "Utilizadores",
    icon: "users",
    link: "/users",
  },
  {
    id: 19,
    label: "Financiadores",
    link: "/projects/financing",
    icon: "dollar-sign",    
  },
  {
    id: 4,
    label: "Orgãos de Estrutura",
    icon: "grid",
    link: "/#",
    subItems: [
      {
        id: 5,
        label: "Listar",
        link: "/units",
        parentId: 4,
      },
      {
        id: 6,
        label: "Tipos",
        link: "/units/types",
        parentId: 4,
      },
      {
        id: 7,
        label: "Membros",
        link: "/units-users",
        parentId: 4,
      },
    ],
  },
  
  
];

export { menuItems };
